/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {
  Drupal.behaviors.eea = {
    attach(context, settings) {
      (function () {
        $(".dropdown, .btn-group").hover(function () {
          const dropdownMenu = $(this).children(".dropdown-menu");
          if (dropdownMenu.is(":visible")) {
            dropdownMenu.parent().toggleClass("open");
          }
        });

        $(".accordion-duration")
          .once()
          .click(function () {
            $(".duration-content").slideToggle("slow");
            $(".dates-content, .access-content, .rsvp-content").slideUp("slow");
          });

        $(".accordion-dates")
          .once()
          .click(function () {
            $(".dates-content").slideToggle("slow");
            $(".duration-content, .access-content, .rsvp-content").slideUp(
              "slow"
            );
          });

        $(".accordion-information")
          .once()
          .click(function () {
            $(".access-content").slideToggle("slow");
            $(".duration-content, .dates-content, .rsvp-content").slideUp(
              "slow"
            );
          });

        $(".accordion-rsvp")
          .once()
          .click(function () {
            $(".rsvp-content").slideToggle("slow");
            $(".dates-content, .duration-content, .access-content").slideUp(
              "slow"
            );
          });

        //Global mobile styling
        function toggleMobileStyle() {
          $(".form-row").toggleClass("full-width show-filter");
          $(".remove-fullscreen-filter").toggleClass("show-close-button");
          $("body").toggleClass("stop-scroll");
          $("details").toggleClass("full-screen-form");
          $("button.form-submit").toggleClass("full-screen-submit");
          $("div.details-wrapper").toggleClass("full-screen-filter-sizing");
          $("summary").toggleClass("mobile-filter-font");
        }

        // Toggle classes on pill click
        $("#show-filter")
          .once("toggle-pill")
          .click(function () {
            $(".filter-header").remove();
            $(".form-row").prepend("<h1 class=filter-header>Filters</h1>");
            toggleMobileStyle();
          });

        //Toggle classes on cross click
        $(".remove-fullscreen-filter")
          .once("toggle-close")
          .click(function () {
            $(".filter-header").remove();
            toggleMobileStyle();
          });

        //Toggle classes when pill is visible
        if ($(window).width() < 768) {
          //Apply filter button
          $(".color-feature")
            .once("toggle-search")
            .click(function () {
              $(".filter-header").remove();
              toggleMobileStyle();
            });
        }

        //Allowing only one dropdown to be open at a time
        var element = document.querySelector(".form-row");

        if ($(".view-course-catalogue-solr").length) {
          element.addEventListener(
            "toggle",
            function (event) {
              if (!event.target.open) return;
              var dropdowns = element.querySelectorAll(".form-wrapper[open]");
              Array.prototype.forEach.call(dropdowns, function (dropdown) {
                if (dropdown === event.target) return;
                dropdown.removeAttribute("open");
              });
            },
            true
          );
        }

        $(document).on("ajaxStop", function () {
          $(".view-course-catalogue-solr .form-wrapper[open]").each(
            function () {
              $(this).removeAttr("open");
            }
          );
        });
      })();

      /* (function() {
        var addModal = function(src, title) {
          $('.custom-modal').remove();
          var modalContent = '<article class="modal custom-modal" tabindex="-1" role="dialog">';
          modalContent += '<div class="modal-dialog" role="document">';
          modalContent += '<div class="modal-content">';
          modalContent += '<div class="modal-header">';
          modalContent += '<h1 class="modal-title h5">' + title + '</h1>';
          modalContent += '<button type="button" class="close" data-dismiss="modal" aria-label="Close">';
          modalContent += '<span aria-hidden="true">&times;</span>';
          modalContent += '</button>';
          modalContent += '</div>';
          modalContent += '<div class="modal-body">';
          modalContent += '<iframe src="' + src + '" title="' + title + '" frameborder="0" style="border: 0 none;" width="100%" height="860px"></iframe>';
          modalContent += '</div>';
          modalContent += '</div>';
          modalContent += '</div>';
          modalContent += '</article>';
          $('body').append(modalContent);
          $('.custom-modal').modal();
        };
        var openEnquireButtonInIframe = function(evt) {
          var $target = $(evt.currentTarget);
          addModal($target.attr('href'), $target.text());
          evt.preventDefault();
        };

        var $tabDetailsButtons = $('a[href*="engineersaustralia.tfaforms.net"]');
        $tabDetailsButtons.off('click.openEnquireButtonInIframe').on('click.openEnquireButtonInIframe', openEnquireButtonInIframe);
      })(); */
    },
  };
})(jQuery, Drupal);
